import { fetcher } from '@commenda/utils';

export async function downloadMessageZipFile(
  chatRoomId: string,
  messageId: string,
  token: string
) {
  const result = fetcher(
    `chatRoom/${chatRoomId}/message/${messageId}/download-zip`,
    { method: 'GET' },
    token
  );

  return result;
}
